module.exports = __webpack_public_path__ + "img/19.351f7c79.jpg";